<div uk-modal id="add-reservation">
    <div class="uk-modal-dialog uk-modal-body">
        <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
            <h2>Ajouter une nouvelle réservation</h2>
            <label class="uk-form-label uk-display-inline-block vop-blue uk-text-bold uk-margin-small-top">
                Utilisateur
            </label>
            <div class="uk-form-controls uk-display-inline-block uk-position-relative" style="width: inherit;">
                <input class="uk-input" type="text" [(ngModel)]="reservation.user" (ngModelChange)="validator()" placeholder="John Doe">
            </div>
        </div>
        <p class="uk-text-right">
            <button class="uk-button uk-button-default uk-modal-close" type="button">Annuler</button>
            <button [disabled]="validated === false" (click)="submit()"
            class="uk-button uk-button-primary vop-background-black" type="button">
                Ajouter
            </button>
        </p>
    </div>
</div>